var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");

var THREE         = require("three");

var Camera3dModel = function (config) {
    lib_core.Model.call(this);

    var self = this;

    // values you can listen too
    this.cameraTarget = this.value("cameraTarget", true);
    this.cameraTarget(new lib_geometry.Coord3d(0,0,0));

    this.perspectiveCameraPosition = this.value("perspectiveCameraPosition", true);
    this.perspectiveCameraPosition(new lib_geometry.Coord3d(0,0,20));

    this.orthoCameraPosition = this.value("orthoCameraPosition", true);
    this.orthoCameraPosition(new lib_geometry.Coord3d(0,0,20));

    this.cameraType = this.value("cameraType", true);
    this.cameraType(0);

    this.state = this.value("state", true);
    this.state("none");

    this.orthoZoom = this.value("orthoZoom", true);
    this.orthoZoom(1);

    this.perspectiveZoom = this.value("perspectiveZoom", true);
    this.perspectiveZoom(1);


    this.perspectiveZoom.onChange("runUpdate", function(val){
        self.updatePositionAndTarget();
    });

    this.orthoZoom.onChange("checkbounds", function(val){
        var oZoom = Math.max( self.minZoom, Math.min( self.maxZoom, val ) );
        self.orthoZoom(oZoom);
    })

    this.fov = config.fov || 60;//60;
    this.near = config.near || 0.1;//0.1;
    this.far = config.far || 2000;//2000;
    this.up = new THREE.Vector3(0, 0, 1);
    this.rotateSpeed = config.rotateSpeed || 1/3000;//1/3000;
    this.zoomSpeed = config.zoomSpeed || 1.02;//1.02;

    //////////////////////////////////////////
    //Do not mess with the values below.  they are set so that ortho and perspective
    //have the same zoom boundaries.  If they are not exactly right the two cameras will get out of sync!
    //PS there has to be a better way to do this....
    /////////////////
    // How far you can dolly in and out ( PerspectiveCamera only )
    this.minDistance = 0.273575;
    this.maxDistance = 148.57;

    // How far you can zoom in and out ( OrthographicCamera only )
    this.maxZoom = 266.2121833;
    this.minZoom = 0.4902;

    // How far you can orbit vertically, upper and lower limits.
    // Range is 0 to Math.PI radians.
    this.minPolarAngle = 0; // radians
    this.maxPolarAngle = Math.PI; // radians

    // How far you can orbit horizontally, upper and lower limits.
    // If set, must be a sub-interval of the interval [ - Math.PI, Math.PI ].
    this.minAzimuthAngle = -Infinity; // radians
    this.maxAzimuthAngle = Infinity; // radians


    // privates
    this.spherical = new THREE.Spherical();
    this.sphericalDelta = new THREE.Spherical();
    this.orthoSpherical = new THREE.Spherical();

    this.panOffset = new THREE.Vector3();

    this.updateOffset = new THREE.Vector3();
    this.updateOrthoOffset = new THREE.Vector3();
        // so camera.up is the orbit axis
    this.updateQuat = new THREE.Quaternion().setFromUnitVectors( new THREE.Vector3( 0, 0, 1 ), new THREE.Vector3( 0, 1, 0 ) );
    this.updateQuatInverse = this.updateQuat.clone().invert();

    this.updateLastPosition = new THREE.Vector3();
    this.updateLastQuaternion = new THREE.Quaternion();

    this.panTempOffset = new THREE.Vector3();
    this.panLeftV = new THREE.Vector3();
    this.panUpV = new THREE.Vector3();

};

lib_core.inherit(Camera3dModel, lib_core.Model);
Camera3dModel.$class = "Camera3dModel";

module.exports = Camera3dModel;

Camera3dModel.prototype.viewToFit = function( object3d ) {
    // *copy pasted code for reference, do not use*
    // [need to solve this with the two camera problem]
    
    // center camera on the object (ellipse in this case)
    // var boundingSphere = object3d.geometry.boundingSphere

    // // aspect equals window.innerWidth / window.innerHeight
    // if( aspect > 1.0 )
    // {
    //     // if view is wider than it is tall, zoom to fit height
    //     camera.zoom = viewHeight / ( boundingSphere.radius * 2 )
    // }
    // else
    // {
    //     // if view is taller than it is wide, zoom to fit width
    //     camera.zoom = viewWidth / ( boundingSphere.radius * 2 )
    // }

    // // Don't forget this
    // camera.updateProjectionMatrix();
}

Camera3dModel.prototype.rotateLeft = function( angle ) {
    this.sphericalDelta.theta -= angle;
    this.updatePositionAndTarget();
}

Camera3dModel.prototype.rotateUp = function( angle ) {
    this.sphericalDelta.phi -= angle;
    this.updatePositionAndTarget();
}

Camera3dModel.prototype.panLeft = function( distance ) {
    var matrix = new THREE.Matrix4();
    matrix.lookAt(
        this.perspectiveCameraPosition().toThreejs(),
        this.cameraTarget().toThreejs(), 
        this.up
    );
    
    this.panLeftV.setFromMatrixColumn( matrix, 0 ); // get X column of objectMatrix
    this.panLeftV.multiplyScalar( - distance );

    this.panOffset.add( this.panLeftV );
    this.updatePositionAndTarget();
}

Camera3dModel.prototype.panUp = function( distance ) {
    var matrix = new THREE.Matrix4();
    matrix.lookAt(
        this.perspectiveCameraPosition().toThreejs(),
        this.cameraTarget().toThreejs(), 
        this.up
    );
    
    this.panUpV.setFromMatrixColumn( matrix, 1 ); // get X column of objectMatrix
    this.panUpV.multiplyScalar( - distance );

    this.panOffset.add( this.panUpV );
    this.updatePositionAndTarget();
}

Camera3dModel.prototype.zoomIn = function( amount ) {
    this.perspectiveZoom( this.perspectiveZoom() / amount);
    this.updatePositionAndTarget();

    var oZoom = Math.max( this.minZoom, Math.min( this.maxZoom, this.orthoZoom() * amount ) );
    this.orthoZoom(oZoom);
}

Camera3dModel.prototype.zoomOut = function( amount ) {
    this.perspectiveZoom( this.perspectiveZoom() * amount);
    this.updatePositionAndTarget();

    var oZoom = Math.max( this.minZoom, Math.min( this.maxZoom, this.orthoZoom() / amount ) );
    this.orthoZoom(oZoom);
}

Camera3dModel.prototype.pan = function( deltaX, deltaY ) {

    // perspective
    var position = this.perspectiveCameraPosition().toThreejs();

    this.panTempOffset.copy( position ).sub( this.cameraTarget() );
    var targetDistance = this.panTempOffset.length();

    // half of the fov is center to top of screen
    targetDistance *= Math.tan( ( 100 ) * Math.PI / 180.0 );

    // we actually don't use screenWidth, since perspective camera is fixed to screen height
    this.panLeft( - 2 * deltaX * targetDistance / 10000);
    this.panUp( 2 * deltaY * targetDistance / 10000);
}


Camera3dModel.prototype.updatePositionAndTarget = function(){

    var position = this.perspectiveCameraPosition().toThreejs();
    var orthoPosition = this.orthoCameraPosition().toThreejs();

    this.updateOffset.copy( position ).sub( this.cameraTarget() );

    // rotate offset to "y-axis-is-up" space
    this.updateOffset.applyQuaternion( this.updateQuat );

    // angle from z-axis around y-axis
    this.spherical.setFromVector3( this.updateOffset );
    this.orthoSpherical.setFromVector3( this.updateOffset );

    this.spherical.theta += this.sphericalDelta.theta;
    this.orthoSpherical.theta += this.sphericalDelta.theta;

    this.spherical.phi += this.sphericalDelta.phi;
    this.orthoSpherical.phi += this.sphericalDelta.phi;

    // restrict theta to be between desired limits
    this.spherical.theta = Math.max( this.minAzimuthAngle, Math.min( this.maxAzimuthAngle, this.spherical.theta ) );
    this.orthoSpherical.theta = Math.max( this.minAzimuthAngle, Math.min( this.maxAzimuthAngle, this.spherical.theta ) );

    // restrict phi to be between desired limits
    this.spherical.phi = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, this.spherical.phi ) );
    this.orthoSpherical.phi = Math.max( this.minPolarAngle, Math.min( this.maxPolarAngle, this.spherical.phi ) );

    this.spherical.makeSafe();
    this.orthoSpherical.makeSafe();

    this.spherical.radius *= this.perspectiveZoom();
    this.orthoSpherical.radius *= 10; // the difference!

    // restrict radius to be between desired limits
    this.spherical.radius = Math.max( this.minDistance, Math.min( this.maxDistance, this.spherical.radius ) );

    // move target to panned location
    var newTarget = this.cameraTarget().toThreejs().add(this.panOffset);
    this.cameraTarget( new lib_geometry.Coord3d().fromThreejs( newTarget ))//scope.target.add( panOffset );

    this.updateOffset.setFromSpherical( this.spherical );
    this.updateOrthoOffset.setFromSpherical( this.orthoSpherical );

    // rotate offset back to "camera-up-vector-is-up" space
    this.updateOffset.applyQuaternion( this.updateQuatInverse );
    this.updateOrthoOffset.applyQuaternion( this.updateQuatInverse );

    position.copy( this.cameraTarget().toThreejs() ).add( this.updateOffset );
    orthoPosition.copy( this.cameraTarget().toThreejs() ).add( this.updateOrthoOffset );

    this.perspectiveCameraPosition(new lib_geometry.Coord3d().fromThreejs( position ));
    this.orthoCameraPosition(new lib_geometry.Coord3d().fromThreejs( orthoPosition ));

    this.sphericalDelta.set( 0, 0, 0 );
    this.perspectiveZoom(1);
    this.panOffset.set( 0, 0, 0 );

}



